import pluralize from "pluralize";
import React from "react";

const OfferHeader = ({ nights, rounds, formattedPrice, deselectOffer }) => {
  const nightsText = pluralize("Night", nights, true);
  const roundsText = pluralize("Round", rounds, true);

  return (
    <div className="featured-offer__header clearfix">
      <div className="venue__offer__from-price">
        <span className="price">£{formattedPrice}</span>
        <div>per person</div>
      </div>

      <span className="venue__offer__back" onClick={deselectOffer}>
        <i className="fa fa-chevron-left"></i>
      </span>

      <div className="venue__offer__summary">
        <h3 className="venue__offer__title">{nightsText}, {roundsText}</h3>
      </div>
    </div>
  );
};

export default OfferHeader;



// WEBPACK FOOTER //
// ./components/last_minute_deals/OfferHeader.js